import { DevotionalText } from "./DevotionalText";
import { DevotionalMemoryVerse } from "./DevotionalMemoryVerse";
import { DevotionalMessage } from "./DevotionalMessage";
import { DevotionalFinalWord } from "./DevotionalFinalWord";
import { DevotionalNotes } from "./DevotionalNotes";
import { SpouseToSpouseSection } from "../SpouseToSpouseSection";
import { PrayerSection } from "../PrayerSection";
import { ReconciliationPrayer } from "../ReconciliationPrayer";

interface DevotionalMainContentProps {
  version: "classic" | "essential";
  text: {
    reference: string;
    content: string;
  };
  memoryVerse: {
    reference: string;
    text: string;
  };
  message: string;
  finalWord: {
    reference: string;
    text: string;
  };
  spouseToSpouse: {
    question: string;
    reconciliation: string;
    prayers: string[];
  };
  morningPrayers: {
    confessions: string[] | string;
    prayerPoints: string[] | string;
  };
  eveningPrayers: {
    confessions: string[] | string;
    prayerPoints: string[] | string;
  };
  userId?: string;
  devotionalId: string;
}

export const DevotionalMainContent = ({
  version,
  text,
  memoryVerse,
  message,
  finalWord,
  spouseToSpouse,
  morningPrayers,
  eveningPrayers,
  userId,
  devotionalId,
}: DevotionalMainContentProps) => {
  // Ensure prayers data is properly formatted
  const formattedEveningPrayers = {
    confessions: Array.isArray(eveningPrayers?.confessions)
      ? eveningPrayers.confessions
      : typeof eveningPrayers?.confessions === 'string'
        ? eveningPrayers.confessions.split('|')
        : [],
    prayerPoints: Array.isArray(eveningPrayers?.prayerPoints)
      ? eveningPrayers.prayerPoints
      : typeof eveningPrayers?.prayerPoints === 'string'
        ? eveningPrayers.prayerPoints.split('|')
        : []
  };

  const formattedMorningPrayers = {
    confessions: Array.isArray(morningPrayers?.confessions)
      ? morningPrayers.confessions
      : typeof morningPrayers?.confessions === 'string'
        ? morningPrayers.confessions.split('|')
        : [],
    prayerPoints: Array.isArray(morningPrayers?.prayerPoints)
      ? morningPrayers.prayerPoints
      : typeof morningPrayers?.prayerPoints === 'string'
        ? morningPrayers.prayerPoints.split('|')
        : []
  };

  return (
    <div className="space-y-6">
      <DevotionalText {...text} />
      <DevotionalMemoryVerse {...memoryVerse} />
      <DevotionalMessage message={message} />

      {version === "classic" && (
        <>
          <SpouseToSpouseSection question={spouseToSpouse.question} />
          <PrayerSection
            title="Morning Prayers"
            confessions={formattedMorningPrayers.confessions}
            prayerPoints={formattedMorningPrayers.prayerPoints}
          />
          <PrayerSection
            title="Evening Prayers"
            confessions={formattedEveningPrayers.confessions}
            prayerPoints={formattedEveningPrayers.prayerPoints}
          />
        </>
      )}

      <DevotionalFinalWord {...finalWord} />
      <DevotionalNotes userId={userId} devotionalId={devotionalId} />
      <ReconciliationPrayer />
    </div>
  );
};